import React from 'react';
import { AdvancedSelectComponent, AdvancedSubHeaderComponent } from '@vivli/shared/components';
import { inputGroupBreakStyle } from '../../search-filters.styles';
import { FilterGroupComponent } from '../../filter-group.component';
import { useCtSearchOptionsContext } from '@vivli/features/search/infrastructure/context';
import { useSearchApiContext } from '@vivli/core/infrastructure/context';

export const SponsorInfoFilterGroupComponent = () => {
    const { ctFilterValues } = useSearchApiContext();
    const { sponsorSelectedOptions, sponsorTypeSelectedOptions, setSponsorSelectedOptions, setSponsorTypeSelectedOptions } =
        useCtSearchOptionsContext();

    const sponsorOptions = ctFilterValues?.sponsorName.map((l) => ({ value: l.value, label: l.value }));
    const sponsorTypeOptions = ctFilterValues?.sponsorType.map((l) => ({ value: l.value, label: l.value }));

    return (
        <FilterGroupComponent title={'SPONSOR INFORMATION'} noBottomPad={true}>
            <div style={inputGroupBreakStyle}>
                <AdvancedSubHeaderComponent title={'SPONSOR TYPE'} />
                <AdvancedSelectComponent
                    dataId={'ctSearchSponsorType'}
                    isMulti={true}
                    isSearchable={true}
                    onChange={setSponsorTypeSelectedOptions}
                    options={sponsorTypeOptions}
                    selectedOptions={sponsorTypeSelectedOptions}
                />
            </div>

            <div>
                <AdvancedSubHeaderComponent title={'SPONSOR'} />
                <AdvancedSelectComponent
                    dataId={'ctSearchSponsor'}
                    isMulti={true}
                    isSearchable={true}
                    onChange={setSponsorSelectedOptions}
                    options={sponsorOptions}
                    selectedOptions={sponsorSelectedOptions}
                />
            </div>
        </FilterGroupComponent>
    );
};
